import { render, staticRenderFns } from "./AbkAttachment.vue?vue&type=template&id=2c20639a&scoped=true&"
import script from "./AbkAttachment.vue?vue&type=script&lang=js&"
export * from "./AbkAttachment.vue?vue&type=script&lang=js&"
import style0 from "./AbkAttachment.vue?vue&type=style&index=0&id=2c20639a&scoped=true&lang=scss&"
import style1 from "./AbkAttachment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c20639a",
  null
  
)

export default component.exports